import { formatDate } from '@angular/common';
import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TranslateService } from '@ngx-translate/core';
import { SolicitudEmvsService } from 'src/app/_services/solicitud-emvs.service';
import { ApiDateValue, AutorizacionFirmaEstado } from '../autorizacion-firma-estado.model';

export interface EstadoFirmaAutorizadosDialogData {
  tramiteId: number;
  nombreTramite: string;
}

@Component({
  selector: 'app-estado-firma-autorizados-dialog',
  templateUrl: './estado-firma-autorizados-dialog.component.html',
  styleUrls: ['./estado-firma-autorizados-dialog.component.scss']
})
export class EstadoFirmaAutorizadosDialogComponent implements OnInit {
  autorizados: AutorizacionFirmaEstado[] = [];
  loading = true;
  error: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<EstadoFirmaAutorizadosDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EstadoFirmaAutorizadosDialogData,
    private solicitudEmvsService: SolicitudEmvsService,
    private translate: TranslateService,
    @Inject(LOCALE_ID) private locale: string
  ) {}

  ngOnInit(): void {
    this.solicitudEmvsService.getEstadoFirmaAutorizadosByTramite(String(this.data.tramiteId)).subscribe({
      next: (response) => {
        this.autorizados = response.body ?? [];
        this.loading = false;
      },
      error: () => {
        this.error = this.translate.instant('COMMON.ERROR');
        this.loading = false;
      }
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  formatFecha(value: ApiDateValue | undefined): string {
    const date = this.parseApiDate(value);
    if (!date) {
      return '-';
    }
    if (this.hasTimeComponent(value)) {
      return formatDate(date, 'dd-MM-yyyy HH:mm', this.locale, 'GMT');
    }
    return formatDate(date, 'dd-MM-yyyy', this.locale, 'GMT');
  }

  private parseApiDate(value: ApiDateValue | undefined): Date | null {
    if (value == null || value === '') {
      return null;
    }
    if (Array.isArray(value)) {
      const [year, month, day, hour = 0, minute = 0, second = 0] = value;
      if (year == null || month == null || day == null) {
        return null;
      }
      return new Date(Date.UTC(year, month - 1, day, hour, minute, second));
    }
    if (typeof value === 'string') {
      const iso = value.includes('T') ? value : `${value}T00:00:00.000Z`;
      const parsed = new Date(iso);
      return isNaN(parsed.getTime()) ? null : parsed;
    }
    return null;
  }

  private hasTimeComponent(value: ApiDateValue | undefined): boolean {
    if (!value) {
      return false;
    }
    if (Array.isArray(value)) {
      return value.length > 3 && ((value[3] ?? 0) !== 0 || (value[4] ?? 0) !== 0 || (value[5] ?? 0) !== 0);
    }
    if (typeof value === 'string') {
      return /T\d{2}:\d{2}/.test(value) && !/T00:00(:00)?/.test(value);
    }
    return false;
  }

  estadoClass(estado: string): string {
    switch (estado) {
      case 'Firmado':
        return 'estado-firma--ok';
      case 'Rechazado':
        return 'estado-firma--ko';
      case 'Pendiente de firma':
        return 'estado-firma--pending';
      default:
        return 'estado-firma--neutral';
    }
  }
}
